<template lang="pug">
  page-template.text-16.uppercase
    .children-mt-em(v-if="doc", v-html="content")

</template>

<script>
import PageTemplate from '@/components/PageTemplate'
export default {
  name: 'Page',
  props: ['slug'],
  data () {
    return {
      doc: null
    }
  },
  metaInfo () {
    return this.doc && {
      title: this.doc.title.rendered
    }
  },
  computed: {
    content () {
      if (!this.doc) return ''
      let content = this.doc.content.rendered
      // stockists, text size manip
      if (this.doc.template.includes('stockists')) {
        content = content.replace(/\(.*\)/gm, (match) => {
          return match.replace('(', '<span class="text-11 md-ml-8">').replace(')', '</span>')
        })
      }
      // serve WYSIWYG images via netlify (mixed content error)
      const wpMediaBase = process.env.VUE_APP_WP_BASE_URL + '/wp-content/'
      const netlifyMediaBase = '/wp-content/'
      content = content.replaceAll(wpMediaBase, netlifyMediaBase)
      return content
    }
  },
  created () {
    this.$store.dispatch('getPage', this.slug).then(doc => { this.doc = doc })
  },
  components: { PageTemplate }
}
</script>

<style>
</style>
